import { isPlatformBrowser } from '@angular/common';
import { ErrorHandler, Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { ErrorTracking } from './error-tracking.service';

@Injectable()
export class CustomErrorHandler extends ErrorHandler {
  isBrowser: boolean;

  constructor(
    @Inject(PLATFORM_ID) platformId: Object,
    private errorTracking: ErrorTracking,
  ) {
    super();
    this.isBrowser = isPlatformBrowser(platformId);
  }

  handleError(error: Error): void {
    // Report to Sentry
    this.errorTracking.captureException(error);
    // Angular's native error handler breaks WebDriverJS console read API.
    // FIXME: detect Protractor env better
    if (this.isBrowser && window.location.host === 'localhost:5000') {
      console.error(error);
    } else {
      super.handleError(error);
    }
  }
}
